import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
Vue.use(Router);


const router = new Router({
  mode: 'history',
  // mode: 'hash',
  base: "/pcweb",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  
})
export default router;